// Keep the parsing logic in sync with server/utils/coords.js.
export function parseCoordinate(input, kind /* 'lat' | 'lng' */) {
  if (kind !== "lat" && kind !== "lng") return null;
  if (typeof input === "number") return normalizeAndValidate(input, kind);
  if (typeof input !== "string") return null;

  let s = input.trim()
    .replace(/,/g, ".")
    .replace(/[′‘’‛´`]/g, "'")
    .replace(/[″“”]/g, '"')
    .replace(/''/g, '"')
    .replace(/\s+/g, " ");
  if (!s) return null;

  // Lowercase s denotes seconds with text units or an explicit prefix direction.
  const textUnits = /deg|m(?=\s*\d)/i.test(s);
  if (textUnits) {
    s = s.replace(/deg/gi, "°").replace(/m(?=\s*\d)/gi, "'");
  }
  if (textUnits || /^[NSEW]\s*[+-]?\d/i.test(s)) {
    s = s.replace(/s(?=\s*[NSEW]?\s*$)/, '"');
  }

  const decimal = s.match(/^([NSEW])?\s*([+-]?(?:\d+(?:\.\d+)?|\.\d+))\s*([NSEW])?$/i);
  const dms = decimal ? null : s.match(/^([NSEW])?\s*([+-]?\d{1,3})\s*(?:°|\s)\s*(\d{1,2})\s*(?:'|\s)\s*(\d{1,2}(?:\.\d+)?)\s*"?\s*([NSEW])?$/i);
  if (!decimal && !dms) return null;

  const [, prefix, degrees] = decimal || dms;
  const suffix = decimal ? decimal[3] : dms[5];
  if (prefix && suffix && prefix.toUpperCase() !== suffix.toUpperCase()) return null;
  const direction = (prefix || suffix || "").toUpperCase();
  if (direction && !(kind === "lat" ? /^[NS]$/ : /^[EW]$/).test(direction)) return null;

  const minutes = dms ? Number(dms[3]) : 0;
  const seconds = dms ? Number(dms[4]) : 0;
  if (minutes >= 60 || seconds >= 60) return null;

  const negative = degrees.startsWith("-");
  if (negative && (direction === "N" || direction === "E")) return null;
  let value = Math.abs(Number(degrees)) + minutes / 60 + seconds / 3600;
  if (direction === "S" || direction === "W" || (!direction && negative)) value *= -1;
  return normalizeAndValidate(value, kind);
}

function normalizeAndValidate(value, kind) {
  const limit = kind === "lat" ? 90 : 180;
  if (!Number.isFinite(value) || Math.abs(value) > limit) return null;
  const rounded = Math.round(value * 1e7) / 1e7;
  return Object.is(rounded, -0) ? 0 : rounded;
}
